import { render, staticRenderFns } from "./PackagesDetail.vue?vue&type=template&id=67dc7a87&scoped=true"
import script from "./PackagesDetail.vue?vue&type=script&lang=ts"
export * from "./PackagesDetail.vue?vue&type=script&lang=ts"
import style0 from "./PackagesDetail.vue?vue&type=style&index=0&id=67dc7a87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dc7a87",
  null
  
)

export default component.exports